import React from 'react';
import { isBreakpoint } from '../utils';
import { useWindowSize, useBreakpoint } from '../utils/hooks';
import { SimpleContainer, SidesContainer } from '../components/Container';
import SectionHeading from './SectionHeading';

import * as css from './Credits.module.css';

const ProjectCredits = ({ credits, id }) => {
  const [winWidth] = useWindowSize();
  const breakpoint = useBreakpoint(winWidth);

  // this makes groups of 1 or 2 depending on breakpoint
  const list = Object.keys(credits).reduce((acc, value, index, array) => {
    const by = isBreakpoint(breakpoint, 'large') ? 1 : 2;
    if (index % by === 0) {
      acc.push(array.slice(index, index + by));
    }
    return acc;
  }, []);
  return (
    <div className={css.root}>
      <SimpleContainer bottomLine className={css.beforeTitle}></SimpleContainer>

      <SectionHeading bottomLine>Credits</SectionHeading>

      {list.map((group, i) => (
        <div className={css.creditRow} key={i}>
          <SidesContainer bottomLine>
            {group.map((key, j) => (
              <dl className={css.credit} key={i + '-' + j}>
                <dt>{key}</dt>
                <dd>{credits[key]}</dd>
              </dl>
            ))}
          </SidesContainer>
        </div>
      ))}
    </div>
  );
};

export default ProjectCredits;
